import { render, staticRenderFns } from "./AccountSetting.vue?vue&type=template&id=1864b0c6&scoped=true"
import script from "./AccountSetting.vue?vue&type=script&lang=js"
export * from "./AccountSetting.vue?vue&type=script&lang=js"
import style0 from "./AccountSetting.vue?vue&type=style&index=0&id=1864b0c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1864b0c6",
  null
  
)

export default component.exports